module.exports = __webpack_public_path__ + "img/45.5ae851b8.jpg";